import { QueryStatus, useQuery } from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetProgramInstituteCoursesRequestObjectSchema,
  GetProgramInstituteCoursesResponseSchema,
  GetProgramInstituteCoursesResponseType
} from '../../../services/NwProductsExtensionsServices/APIService/types';

import { useNwProductsExtensionsService } from '../useNwProductsExtensionsService';

interface UseGetProgramInstituteCoursesApiInterface {
  data: GetProgramInstituteCoursesResponseType | undefined;
  isLoading: boolean;
  isError: boolean;
  error: string | null;
  status: QueryStatus;
  refetch: () => Promise<unknown>;
  isFetching: boolean;
}

const useGetProgramInstituteCoursesApi = (
  programId: number,
  instituteId: string,
  enabled = true
): UseGetProgramInstituteCoursesApiInterface => {
  const { nwProductsExtensionsServiceInstance } =
    useNwProductsExtensionsService();

  const getProgramInstituteCourses = () => {
    const requestObject = {
      program_id: programId,
      institute_id: instituteId
    };
    try {
      GetProgramInstituteCoursesRequestObjectSchema.parse(requestObject);
    } catch (error) {
      console.error('Invalid request object:', error);
      throw error;
    }

    return nwProductsExtensionsServiceInstance
      .getProgramInstituteCourses(requestObject)
      .then((response) => {
        try {
          GetProgramInstituteCoursesResponseSchema.parse(response);
        } catch (error) {
          console.error('Invalid response object:', error);
          throw error;
        }
        return response;
      });
  };

  const { data, isLoading, isError, error, status, refetch, isFetching } =
    useQuery(
      ['getProgramInstituteCourses', programId, instituteId],
      getProgramInstituteCourses,
      {
        enabled: Boolean(programId) && Boolean(instituteId) && enabled,
        staleTime: 60000
      }
    );

  return {
    data,
    isLoading,
    isError,
    error: error ? getAPIErrorMessage(error) : null,
    status,
    refetch,
    isFetching
  };
};

export { useGetProgramInstituteCoursesApi };
